export var AppAccessTokenTable;
(function (AppAccessTokenTable) {
    let Type;
    (function (Type) {
        Type.map = {};
        Type.Download = 10;
        Type.map[Type.Download] = 'ダウンロード';
        Type.Upload = 20;
        Type.map[Type.Upload] = 'アップロード';
    })(Type = AppAccessTokenTable.Type || (AppAccessTokenTable.Type = {}));
})(AppAccessTokenTable || (AppAccessTokenTable = {}));
